import axios, { AxiosRequestConfig } from 'axios';

export const fetchAll = async <T>(
  url: string,
  config?: AxiosRequestConfig,
  prevResults: T[] = []
): Promise<{ value: T[]; '@odata.count': number }> => {
  const { data } = await axios.get<{ value: T[]; '@odata.count': number }>(url, config);
  const results = prevResults.concat(data.value);

  return results.length < data['@odata.count']
    ? fetchAll(
        url,
        {
          ...config,
          params: {
            ...config?.params,
            $skip: results.length
          }
        },
        results
      )
    : {
        value: results,
        '@odata.count': data['@odata.count']
      };
};
